function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404Cat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-89"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "450.37 229.57 415.79 229.57 415.79 271.57 406.89 271.57 406.89 247.79 362.91 247.79 362.91 285.44 357.09 285.44 357.09 197.08 318.87 197.08 318.87 221.34 299.28 221.34 299.28 251.51 293.35 251.51 293.35 232.53 258.6 232.53 258.6 289.17 248.44 289.17 248.44 243.12 216.66 243.12 216.66 208.16 195.05 208.16 195.05 188.25 170.06 188.25 170.06 276.57 161.66 276.57 161.66 239.71 120.48 239.71 120.48 292.47 114.79 292.47 114.79 249.41 73.03 249.41 73.03 210.61 49.63 210.61 49.63 391.31 450.37 391.31 450.37 229.57",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.28,
    y: 234.85,
    width: 5.85,
    height: 8.03,
    transform: "translate(886.41 477.73) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.14,
    y: 234.85,
    width: 5.85,
    height: 8.03,
    transform: "translate(866.13 477.73) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420,
    y: 234.85,
    width: 5.85,
    height: 8.03,
    transform: "translate(845.84 477.73) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.28,
    y: 246.93,
    width: 5.85,
    height: 8.03,
    transform: "translate(886.41 501.89) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.14,
    y: 246.93,
    width: 5.85,
    height: 8.03,
    transform: "translate(866.13 501.89) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420,
    y: 246.93,
    width: 5.85,
    height: 8.03,
    transform: "translate(845.84 501.89) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.28,
    y: 259.01,
    width: 5.85,
    height: 8.03,
    transform: "translate(886.41 526.05) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.14,
    y: 259.01,
    width: 5.85,
    height: 8.03,
    transform: "translate(866.13 526.05) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420,
    y: 259.01,
    width: 5.85,
    height: 8.03,
    transform: "translate(845.84 526.05) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.28,
    y: 271.09,
    width: 5.85,
    height: 8.03,
    transform: "translate(886.41 550.22) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.14,
    y: 271.09,
    width: 5.85,
    height: 8.03,
    transform: "translate(866.13 550.22) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420,
    y: 271.09,
    width: 5.85,
    height: 8.03,
    transform: "translate(845.84 550.22) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.7,
    y: 248.86,
    width: 5.85,
    height: 6.7,
    transform: "translate(481.26 504.43) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.56,
    y: 248.86,
    width: 5.85,
    height: 6.7,
    transform: "translate(460.98 504.43) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.42,
    y: 248.86,
    width: 5.85,
    height: 6.7,
    transform: "translate(440.69 504.43) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.7,
    y: 258.94,
    width: 5.85,
    height: 6.7,
    transform: "translate(481.26 524.58) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.56,
    y: 258.94,
    width: 5.85,
    height: 6.7,
    transform: "translate(460.98 524.58) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.42,
    y: 258.94,
    width: 5.85,
    height: 6.7,
    transform: "translate(440.69 524.58) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.7,
    y: 269.02,
    width: 5.85,
    height: 6.7,
    transform: "translate(481.26 544.74) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.56,
    y: 269.02,
    width: 5.85,
    height: 6.7,
    transform: "translate(460.98 544.74) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.42,
    y: 269.02,
    width: 5.85,
    height: 6.7,
    transform: "translate(440.69 544.74) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.7,
    y: 279.1,
    width: 5.85,
    height: 6.7,
    transform: "translate(481.26 564.9) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.56,
    y: 279.1,
    width: 5.85,
    height: 6.7,
    transform: "translate(460.98 564.9) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.42,
    y: 279.1,
    width: 5.85,
    height: 6.7,
    transform: "translate(440.69 564.9) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.7,
    y: 289.43,
    width: 5.85,
    height: 6.7,
    transform: "translate(481.26 585.56) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.56,
    y: 289.43,
    width: 5.85,
    height: 6.7,
    transform: "translate(460.98 585.56) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.42,
    y: 289.43,
    width: 5.85,
    height: 6.7,
    transform: "translate(440.69 585.56) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.7,
    y: 299.76,
    width: 5.85,
    height: 6.7,
    transform: "translate(481.26 606.22) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.56,
    y: 299.76,
    width: 5.85,
    height: 6.7,
    transform: "translate(460.98 606.22) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.42,
    y: 299.76,
    width: 5.85,
    height: 6.7,
    transform: "translate(440.69 606.22) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.7,
    y: 310.09,
    width: 5.85,
    height: 6.7,
    transform: "translate(481.26 626.87) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.56,
    y: 310.09,
    width: 5.85,
    height: 6.7,
    transform: "translate(460.98 626.87) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.42,
    y: 310.09,
    width: 5.85,
    height: 6.7,
    transform: "translate(440.69 626.87) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.7,
    y: 320.42,
    width: 5.85,
    height: 6.7,
    transform: "translate(481.26 647.53) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.56,
    y: 320.42,
    width: 5.85,
    height: 6.7,
    transform: "translate(460.98 647.53) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.42,
    y: 320.42,
    width: 5.85,
    height: 6.7,
    transform: "translate(440.69 647.53) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.21,
    y: 252.94,
    width: 33.68,
    height: 5.02,
    transform: "translate(770.1 510.9) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.21,
    y: 262.68,
    width: 33.68,
    height: 5.02,
    transform: "translate(770.1 530.39) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.21,
    y: 272.43,
    width: 33.68,
    height: 5.02,
    transform: "translate(770.1 549.88) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.21,
    y: 282.17,
    width: 33.68,
    height: 5.02,
    transform: "translate(770.1 569.36) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.21,
    y: 291.91,
    width: 33.68,
    height: 5.02,
    transform: "translate(770.1 588.85) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.21,
    y: 301.66,
    width: 33.68,
    height: 5.02,
    transform: "translate(770.1 608.34) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.21,
    y: 311.4,
    width: 33.68,
    height: 5.02,
    transform: "translate(770.1 627.83) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.21,
    y: 321.15,
    width: 33.68,
    height: 5.02,
    transform: "translate(770.1 647.31) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.71,
    y: 244.4,
    width: 30.97,
    height: 5.02,
    transform: "translate(282.38 493.81) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.71,
    y: 254.14,
    width: 30.97,
    height: 5.02,
    transform: "translate(282.38 513.3) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.71,
    y: 263.88,
    width: 30.97,
    height: 5.02,
    transform: "translate(282.38 532.79) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.71,
    y: 273.63,
    width: 30.97,
    height: 5.02,
    transform: "translate(282.38 552.28) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.71,
    y: 283.37,
    width: 30.97,
    height: 5.02,
    transform: "translate(282.38 571.76) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.71,
    y: 293.11,
    width: 30.97,
    height: 5.02,
    transform: "translate(282.38 591.25) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.71,
    y: 302.86,
    width: 30.97,
    height: 5.02,
    transform: "translate(282.38 610.74) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.71,
    y: 312.6,
    width: 30.97,
    height: 5.02,
    transform: "translate(282.38 630.23) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.71,
    y: 321.86,
    width: 30.97,
    height: 5.02,
    transform: "translate(282.38 648.74) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.71,
    y: 331.12,
    width: 30.97,
    height: 5.02,
    transform: "translate(282.38 667.26) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.71,
    y: 340.38,
    width: 30.97,
    height: 5.02,
    transform: "translate(282.38 685.78) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.71,
    y: 349.64,
    width: 30.97,
    height: 5.02,
    transform: "translate(282.38 704.29) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.71,
    y: 358.9,
    width: 30.97,
    height: 5.02,
    transform: "translate(282.38 722.81) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.63,
    y: 256.17,
    width: 32.71,
    height: 5.02,
    transform: "translate(183.98 517.35) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.63,
    y: 265.91,
    width: 32.71,
    height: 5.02,
    transform: "translate(183.98 536.84) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.63,
    y: 275.65,
    width: 32.71,
    height: 5.02,
    transform: "translate(183.98 556.33) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.63,
    y: 285.4,
    width: 32.71,
    height: 5.02,
    transform: "translate(183.98 575.82) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.63,
    y: 295.14,
    width: 32.71,
    height: 5.02,
    transform: "translate(183.98 595.3) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.63,
    y: 304.88,
    width: 32.71,
    height: 5.02,
    transform: "translate(183.98 614.79) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.63,
    y: 314.63,
    width: 32.71,
    height: 5.02,
    transform: "translate(183.98 634.28) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.63,
    y: 324.37,
    width: 32.71,
    height: 5.02,
    transform: "translate(183.98 653.77) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.63,
    y: 333.09,
    width: 32.71,
    height: 5.02,
    transform: "translate(183.98 671.21) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.63,
    y: 341.81,
    width: 32.71,
    height: 5.02,
    transform: "translate(183.98 688.65) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.63,
    y: 350.53,
    width: 32.71,
    height: 5.02,
    transform: "translate(183.98 706.09) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.78,
    y: 237.08,
    width: 10.4,
    height: 4.85,
    transform: "translate(555.96 479.01) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.78,
    y: 246.49,
    width: 10.4,
    height: 4.85,
    transform: "translate(555.96 497.83) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.78,
    y: 255.9,
    width: 10.4,
    height: 4.85,
    transform: "translate(555.96 516.65) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.78,
    y: 265.31,
    width: 10.4,
    height: 4.85,
    transform: "translate(555.96 535.47) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.78,
    y: 274.72,
    width: 10.4,
    height: 4.85,
    transform: "translate(555.96 554.29) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.78,
    y: 284.13,
    width: 10.4,
    height: 4.85,
    transform: "translate(555.96 573.11) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.78,
    y: 293.54,
    width: 10.4,
    height: 4.85,
    transform: "translate(555.96 591.93) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.78,
    y: 302.95,
    width: 10.4,
    height: 4.85,
    transform: "translate(555.96 610.75) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.62,
    y: 237.08,
    width: 10.4,
    height: 4.85,
    transform: "translate(527.65 479.01) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.62,
    y: 246.49,
    width: 10.4,
    height: 4.85,
    transform: "translate(527.65 497.83) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.62,
    y: 255.9,
    width: 10.4,
    height: 4.85,
    transform: "translate(527.65 516.65) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.62,
    y: 265.31,
    width: 10.4,
    height: 4.85,
    transform: "translate(527.65 535.47) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.62,
    y: 274.72,
    width: 10.4,
    height: 4.85,
    transform: "translate(527.65 554.29) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.62,
    y: 284.13,
    width: 10.4,
    height: 4.85,
    transform: "translate(527.65 573.11) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.62,
    y: 293.54,
    width: 10.4,
    height: 4.85,
    transform: "translate(527.65 591.93) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.62,
    y: 302.95,
    width: 10.4,
    height: 4.85,
    transform: "translate(527.65 610.75) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.46,
    y: 202.17,
    width: 10.84,
    height: 7.65,
    transform: "translate(691.75 411.99) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.3,
    y: 202.17,
    width: 10.84,
    height: 7.65,
    transform: "translate(659.44 411.99) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.46,
    y: 213.41,
    width: 10.84,
    height: 7.65,
    transform: "translate(691.75 434.46) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.3,
    y: 213.41,
    width: 10.84,
    height: 7.65,
    transform: "translate(659.44 434.46) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.46,
    y: 224.64,
    width: 10.84,
    height: 7.65,
    transform: "translate(691.75 456.93) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.3,
    y: 224.64,
    width: 10.84,
    height: 7.65,
    transform: "translate(659.44 456.93) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.46,
    y: 235.88,
    width: 10.84,
    height: 7.65,
    transform: "translate(691.75 479.4) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.3,
    y: 235.88,
    width: 10.84,
    height: 7.65,
    transform: "translate(659.44 479.4) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.46,
    y: 247.11,
    width: 10.84,
    height: 7.65,
    transform: "translate(691.75 501.87) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.3,
    y: 247.11,
    width: 10.84,
    height: 7.65,
    transform: "translate(659.44 501.87) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.46,
    y: 258.34,
    width: 10.84,
    height: 7.65,
    transform: "translate(691.75 524.34) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.3,
    y: 258.34,
    width: 10.84,
    height: 7.65,
    transform: "translate(659.44 524.34) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.46,
    y: 269.58,
    width: 10.84,
    height: 7.65,
    transform: "translate(691.75 546.81) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.3,
    y: 269.58,
    width: 10.84,
    height: 7.65,
    transform: "translate(659.44 546.81) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.46,
    y: 280.81,
    width: 10.84,
    height: 7.65,
    transform: "translate(691.75 569.28) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.3,
    y: 280.81,
    width: 10.84,
    height: 7.65,
    transform: "translate(659.44 569.28) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.28,
    y: 224.64,
    width: 10.84,
    height: 7.65,
    transform: "translate(619.39 456.93) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.28,
    y: 235.88,
    width: 10.84,
    height: 7.65,
    transform: "translate(619.39 479.4) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.28,
    y: 247.11,
    width: 10.84,
    height: 7.65,
    transform: "translate(619.39 501.87) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.28,
    y: 258.34,
    width: 10.84,
    height: 7.65,
    transform: "translate(619.39 524.34) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.28,
    y: 269.58,
    width: 10.84,
    height: 7.65,
    transform: "translate(619.39 546.81) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.28,
    y: 280.81,
    width: 10.84,
    height: 7.65,
    transform: "translate(619.39 569.28) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.46,
    y: 291.91,
    width: 10.84,
    height: 7.65,
    transform: "translate(691.75 591.48) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.3,
    y: 291.91,
    width: 10.84,
    height: 7.65,
    transform: "translate(659.44 591.48) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.28,
    y: 291.91,
    width: 10.84,
    height: 7.65,
    transform: "translate(619.39 591.48) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.46,
    y: 303.02,
    width: 10.84,
    height: 7.65,
    transform: "translate(691.75 613.68) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.3,
    y: 303.02,
    width: 10.84,
    height: 7.65,
    transform: "translate(659.44 613.68) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.28,
    y: 303.02,
    width: 10.84,
    height: 7.65,
    transform: "translate(619.39 613.68) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.46,
    y: 314.12,
    width: 10.84,
    height: 7.65,
    transform: "translate(691.75 635.88) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.3,
    y: 314.12,
    width: 10.84,
    height: 7.65,
    transform: "translate(659.44 635.88) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.28,
    y: 314.12,
    width: 10.84,
    height: 7.65,
    transform: "translate(619.39 635.88) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.46,
    y: 325.22,
    width: 10.84,
    height: 7.65,
    transform: "translate(691.75 658.08) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.3,
    y: 325.22,
    width: 10.84,
    height: 7.65,
    transform: "translate(659.44 658.08) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.28,
    y: 325.22,
    width: 10.84,
    height: 7.65,
    transform: "translate(619.39 658.08) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.46,
    y: 336.32,
    width: 10.84,
    height: 7.65,
    transform: "translate(691.75 680.28) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.3,
    y: 336.32,
    width: 10.84,
    height: 7.65,
    transform: "translate(659.44 680.28) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.28,
    y: 336.32,
    width: 10.84,
    height: 7.65,
    transform: "translate(619.39 680.28) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.39,
    y: 213.09,
    width: 5.85,
    height: 6.7,
    transform: "translate(418.64 432.87) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.25,
    y: 213.09,
    width: 5.85,
    height: 6.7,
    transform: "translate(398.36 432.87) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.39,
    y: 223.17,
    width: 5.85,
    height: 6.7,
    transform: "translate(418.64 453.03) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.25,
    y: 223.17,
    width: 5.85,
    height: 6.7,
    transform: "translate(398.36 453.03) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.39,
    y: 233.25,
    width: 5.85,
    height: 6.7,
    transform: "translate(418.64 473.19) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.25,
    y: 233.25,
    width: 5.85,
    height: 6.7,
    transform: "translate(398.36 473.19) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.39,
    y: 243.32,
    width: 5.85,
    height: 6.7,
    transform: "translate(418.64 493.35) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.25,
    y: 243.32,
    width: 5.85,
    height: 6.7,
    transform: "translate(398.36 493.35) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.39,
    y: 253.65,
    width: 5.85,
    height: 6.7,
    transform: "translate(418.64 514.01) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.25,
    y: 253.65,
    width: 5.85,
    height: 6.7,
    transform: "translate(398.36 514.01) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.39,
    y: 263.98,
    width: 5.85,
    height: 6.7,
    transform: "translate(418.64 534.66) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.25,
    y: 263.98,
    width: 5.85,
    height: 6.7,
    transform: "translate(398.36 534.66) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.39,
    y: 274.31,
    width: 5.85,
    height: 6.7,
    transform: "translate(418.64 555.32) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.25,
    y: 274.31,
    width: 5.85,
    height: 6.7,
    transform: "translate(398.36 555.32) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.39,
    y: 284.64,
    width: 5.85,
    height: 6.7,
    transform: "translate(418.64 575.98) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.25,
    y: 284.64,
    width: 5.85,
    height: 6.7,
    transform: "translate(398.36 575.98) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.39,
    y: 295.08,
    width: 5.85,
    height: 6.7,
    transform: "translate(418.64 596.86) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.25,
    y: 295.08,
    width: 5.85,
    height: 6.7,
    transform: "translate(398.36 596.86) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.39,
    y: 305.52,
    width: 5.85,
    height: 6.7,
    transform: "translate(418.64 617.73) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.25,
    y: 305.52,
    width: 5.85,
    height: 6.7,
    transform: "translate(398.36 617.73) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.39,
    y: 315.96,
    width: 5.85,
    height: 6.7,
    transform: "translate(418.64 638.61) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.25,
    y: 315.96,
    width: 5.85,
    height: 6.7,
    transform: "translate(398.36 638.61) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.39,
    y: 326.39,
    width: 5.85,
    height: 6.7,
    transform: "translate(418.64 659.49) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.25,
    y: 326.39,
    width: 5.85,
    height: 6.7,
    transform: "translate(398.36 659.49) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.52,
    y: 214.18,
    width: 5.85,
    height: 7.89,
    transform: "translate(132.88 436.24) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.37,
    y: 214.18,
    width: 5.85,
    height: 7.89,
    transform: "translate(112.6 436.24) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.52,
    y: 226.05,
    width: 5.85,
    height: 7.89,
    transform: "translate(132.88 459.99) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.37,
    y: 226.05,
    width: 5.85,
    height: 7.89,
    transform: "translate(112.6 459.99) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.52,
    y: 237.93,
    width: 5.85,
    height: 7.89,
    transform: "translate(132.88 483.74) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.37,
    y: 237.93,
    width: 5.85,
    height: 7.89,
    transform: "translate(112.6 483.74) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.52,
    y: 249.8,
    width: 5.85,
    height: 7.89,
    transform: "translate(132.88 507.49) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.37,
    y: 249.8,
    width: 5.85,
    height: 7.89,
    transform: "translate(112.6 507.49) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.52,
    y: 261.97,
    width: 5.85,
    height: 7.89,
    transform: "translate(132.88 531.83) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.37,
    y: 261.97,
    width: 5.85,
    height: 7.89,
    transform: "translate(112.6 531.83) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.52,
    y: 274.14,
    width: 5.85,
    height: 7.89,
    transform: "translate(132.88 556.17) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.37,
    y: 274.14,
    width: 5.85,
    height: 7.89,
    transform: "translate(112.6 556.17) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.52,
    y: 286.31,
    width: 5.85,
    height: 7.89,
    transform: "translate(132.88 580.5) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.37,
    y: 286.31,
    width: 5.85,
    height: 7.89,
    transform: "translate(112.6 580.5) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.52,
    y: 298.47,
    width: 5.85,
    height: 7.89,
    transform: "translate(132.88 604.84) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.37,
    y: 298.47,
    width: 5.85,
    height: 7.89,
    transform: "translate(112.6 604.84) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.52,
    y: 310.77,
    width: 5.85,
    height: 7.89,
    transform: "translate(132.88 629.44) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.37,
    y: 310.77,
    width: 5.85,
    height: 7.89,
    transform: "translate(112.6 629.44) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.52,
    y: 323.07,
    width: 5.85,
    height: 7.89,
    transform: "translate(132.88 654.03) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.37,
    y: 323.07,
    width: 5.85,
    height: 7.89,
    transform: "translate(112.6 654.03) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.52,
    y: 335.37,
    width: 5.85,
    height: 7.89,
    transform: "translate(132.88 678.63) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.37,
    y: 335.37,
    width: 5.85,
    height: 7.89,
    transform: "translate(112.6 678.63) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.52,
    y: 347.66,
    width: 5.85,
    height: 7.89,
    transform: "translate(132.88 703.22) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.37,
    y: 347.66,
    width: 5.85,
    height: 7.89,
    transform: "translate(112.6 703.22) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.71,
    y: 213.09,
    width: 5.85,
    height: 6.7,
    transform: "translate(375.26 432.87) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.57,
    y: 213.09,
    width: 5.85,
    height: 6.7,
    transform: "translate(354.98 432.87) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.71,
    y: 202.75,
    width: 5.85,
    height: 6.7,
    transform: "translate(375.26 412.2) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.57,
    y: 202.75,
    width: 5.85,
    height: 6.7,
    transform: "translate(354.98 412.2) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.71,
    y: 192.42,
    width: 5.85,
    height: 6.7,
    transform: "translate(375.26 391.54) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.57,
    y: 192.42,
    width: 5.85,
    height: 6.7,
    transform: "translate(354.98 391.54) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.71,
    y: 223.17,
    width: 5.85,
    height: 6.7,
    transform: "translate(375.26 453.03) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.57,
    y: 223.17,
    width: 5.85,
    height: 6.7,
    transform: "translate(354.98 453.03) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.71,
    y: 233.25,
    width: 5.85,
    height: 6.7,
    transform: "translate(375.26 473.19) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.57,
    y: 233.25,
    width: 5.85,
    height: 6.7,
    transform: "translate(354.98 473.19) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.71,
    y: 243.32,
    width: 5.85,
    height: 6.7,
    transform: "translate(375.26 493.35) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.57,
    y: 243.32,
    width: 5.85,
    height: 6.7,
    transform: "translate(354.98 493.35) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.71,
    y: 253.65,
    width: 5.85,
    height: 6.7,
    transform: "translate(375.26 514.01) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.57,
    y: 253.65,
    width: 5.85,
    height: 6.7,
    transform: "translate(354.98 514.01) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.71,
    y: 263.98,
    width: 5.85,
    height: 6.7,
    transform: "translate(375.26 534.66) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.57,
    y: 263.98,
    width: 5.85,
    height: 6.7,
    transform: "translate(354.98 534.66) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.71,
    y: 274.31,
    width: 5.85,
    height: 6.7,
    transform: "translate(375.26 555.32) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.57,
    y: 274.31,
    width: 5.85,
    height: 6.7,
    transform: "translate(354.98 555.32) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.71,
    y: 284.64,
    width: 5.85,
    height: 6.7,
    transform: "translate(375.26 575.98) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.57,
    y: 284.64,
    width: 5.85,
    height: 6.7,
    transform: "translate(354.98 575.98) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.71,
    y: 295.08,
    width: 5.85,
    height: 6.7,
    transform: "translate(375.26 596.86) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.57,
    y: 295.08,
    width: 5.85,
    height: 6.7,
    transform: "translate(354.98 596.86) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.71,
    y: 305.52,
    width: 5.85,
    height: 6.7,
    transform: "translate(375.26 617.73) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.57,
    y: 305.52,
    width: 5.85,
    height: 6.7,
    transform: "translate(354.98 617.73) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.71,
    y: 315.96,
    width: 5.85,
    height: 6.7,
    transform: "translate(375.26 638.61) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.57,
    y: 315.96,
    width: 5.85,
    height: 6.7,
    transform: "translate(354.98 638.61) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.71,
    y: 326.39,
    width: 5.85,
    height: 6.7,
    transform: "translate(375.26 659.49) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.57,
    y: 326.39,
    width: 5.85,
    height: 6.7,
    transform: "translate(354.98 659.49) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.11,173.85H338.44s10.68-29.16,27.11-29.16,21.57,20.13,21.57,20.13,11.09-10.94,20.2-10.94,17,14.45,17,14.45S437.21,160.56,446.11,173.85Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.85,116.18H335.53s11.24-16.29,20.1-16.29,11.48,10.86,11.48,10.86,6.25-5.07,12-4.16S385.85,116.18,385.85,116.18Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.9,165.17h-98s13.42-30,27.78-31.84,21.22,22.26,21.22,22.26,9.26-8.53,16.54-8.53,12.91,11.24,12.91,11.24S146.9,150.6,151.9,165.17Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.05,91H178.84s11.37-21.71,23.71-22,18.82,16.43,18.82,16.43S240.56,70,245.05,91Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-89"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 290.26,
    cy: 432.49,
    rx: 163.04,
    ry: 10.79,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-89"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "484.34 391.31 425.75 391.55 367.17 391.64 250 391.8 132.83 391.64 74.25 391.55 15.66 391.31 74.25 391.06 132.83 390.97 250 390.81 367.17 390.97 425.75 391.06 484.34 391.31",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-89"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.69,236.64c16.92,17.6,67.75,95.93,71.71,98.27,0,0,0,51.23-28.31,41s-54.26-102.14-59.8-131.44C223.37,229,228.87,222.28,242.69,236.64Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.38,297.2l51.88-5.9s-32.18-42.69-48.81-57.93c-17.34-15.88-25.84-13.65-17.8,16.43C231.73,280.06,238.38,297.2,238.38,297.2Z",
    style: {
      fill: "#66CC8A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.94,268.94a16.24,16.24,0,0,0-1.08,4.47,17.77,17.77,0,0,0,3.27-8.5A15.52,15.52,0,0,0,235.94,268.94Zm29.14,1.17a16.09,16.09,0,0,0-4.46-1.08,17.68,17.68,0,0,0,8.49,3.27A15.36,15.36,0,0,0,265.08,270.11Zm-7.73,20.18a16.21,16.21,0,0,0-2.4-3.91,16.19,16.19,0,0,0,1.32,4.39,15.23,15.23,0,0,0,2.38,3.92A16.33,16.33,0,0,0,257.35,290.29Zm-30.44-65c-.26-.55-.52-1.09-.82-1.63a5.49,5.49,0,0,0-1.07,0c.24.73.51,1.43.81,2.13a15.73,15.73,0,0,0,2.39,3.92A16.31,16.31,0,0,0,226.91,225.29Zm59.79,61.34-1,.4a16.48,16.48,0,0,0-3.93,2.39,16.31,16.31,0,0,0,4.41-1.31c.4-.18.79-.37,1.18-.58Zm-40-41.21a16.38,16.38,0,0,0-3.92,2.38,16,16,0,0,0,4.41-1.3,16.22,16.22,0,0,0,3.92-2.39A16,16,0,0,0,246.68,245.42Zm-3.48.09a1.92,1.92,0,0,0-.17.13l.18,0S243.2,245.54,243.2,245.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.87,287.87c1.21-.28,2.48-.39,3.71-.56l3.82-.53c2.57-.36,5.15-.68,7.73-1,5.16-.6,10.32-1.23,15.49-1.74,1.42-.14,2.85-.28,4.27-.39s3-.11,4.5-.22c.09,0,.09.13,0,.14-1.27.19-2.53.48-3.8.68s-2.62.38-3.93.54c-2.57.33-5.16.63-7.74.92-5.08.55-10.17,1.13-15.27,1.58l-4.26.36c-1.49.13-3,.35-4.5.34A.07.07,0,0,1,240.87,287.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.55,294.34l-25.16,2.86s-6.65-17.14-14.74-47.4c-3.41-12.76-3.84-20.51-1.88-24Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.77,403.9H173.86c-.65-2.54-1.28-5-1.91-7.5-.72-2.83-1.43-5.59-2.11-8.28-.15-.6-.31-1.2-.46-1.79q-.78-3.09-1.53-6c-.3-1.19-.6-2.36-.89-3.52s-.6-2.34-.89-3.47c-.08-.3-.15-.6-.23-.89l-.24-1-.3-1.17h0c-.11-.41-.21-.81-.31-1.21-.2-.76-.39-1.51-.57-2.24-.28-1.08-.55-2.14-.81-3.17-.11-.45-.23-.9-.34-1.34-.19-.72-.37-1.42-.54-2.11-.12-.46-.23-.91-.34-1.35q-.7-2.72-1.3-5.1c-.11-.42-.21-.83-.32-1.23-.17-.69-.34-1.35-.5-2q-.17-.6-.3-1.17c-.35-1.36-.67-2.6-.94-3.69-.08-.29-.15-.57-.22-.84-.18-.72-.35-1.36-.49-1.93-.06-.23-.11-.45-.17-.65l-.16-.63c0-.14-.07-.28-.1-.4l-.14-.54q0-.13-.06-.24l-.18-.71h76.81s2.53,8.72,6.58,22.78c.82,2.86,1.71,6,2.66,9.23C246.25,381.12,249.39,392.06,252.77,403.9Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.78,403.9h-2q-4.38-18.13-8.49-36.33-1-4.43-2-8.86l-.18-.83a.12.12,0,0,1,.23-.06c0,.09.05.18.08.27q1.33,4.76,2.65,9.53Q182.14,385.71,186.78,403.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.83,339.74l-3.39,17-2.78,13.92-4.73,23.72-.49,2.43-.81,4.05L219,403.9H173.85c-.64-2.55-1.28-5-1.9-7.5-.72-2.83-1.43-5.59-2.11-8.28-.15-.6-.31-1.2-.46-1.79q-.78-3.09-1.53-6c-.3-1.19-.6-2.36-.89-3.52s-.6-2.34-.89-3.47c-.08-.3-.15-.6-.23-.89l-.24-1-.3-1.17h0c-.11-.41-.21-.81-.31-1.21-.2-.76-.39-1.51-.57-2.24-.28-1.08-.55-2.14-.81-3.17-.12-.46-.23-.9-.34-1.34-.19-.72-.37-1.42-.54-2.11-.12-.46-.23-.91-.34-1.35q-.7-2.72-1.3-5.1c-.11-.42-.21-.83-.32-1.23-.17-.69-.34-1.35-.5-2q-.17-.6-.3-1.17c-.35-1.36-.67-2.6-.94-3.69-.08-.29-.15-.57-.22-.84-.18-.72-.35-1.36-.49-1.93-.06-.23-.11-.45-.17-.65l-.16-.63c0-.14-.07-.28-.1-.4l-.14-.54q0-.13-.06-.24l-.18-.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.84,339.71v0c0,.42-.32,5-1.06,12-.21,2-.46,4.28-.75,6.68-.45,3.79-1,8-1.7,12.39-1.18,7.71-2.72,16.12-4.72,24.34-.71,3-1.49,5.89-2.32,8.76l-99.15,0c1.17-15.11,2.24-28.78,3.09-39.55,1.19-15.16,2-24.65,2-24.65l89.94,0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.63,348.82c-.11,3.55-.26,7.09-.49,10.62-.24,3.83-.59,7.65-1.09,11.47,0,.14,0,.28-.05.42q-.7,5.37-1.61,10.71c-.57,3.32-1,6.9-2.46,10a9.75,9.75,0,0,1-2.32,3.13,6.85,6.85,0,0,1-3.17,1.64,3.83,3.83,0,0,1-.59.1h-.17a.22.22,0,0,1,.11.21c0,1.19,0,2.4-.14,3.58,0,.05,0,.1,0,.15-.12,1-.31,2.05-.5,3.07h-1.7l0-.06c.3-1.12.55-2.25.83-3.38s.68-2.28.95-3.45a.23.23,0,0,1,.08-.11,5.29,5.29,0,0,1-5.12-3.21,9.19,9.19,0,0,1-.08-4.66c.31-2,.61-4.06.92-6.09.58-3.73,1.33-7.42,2-11.13l.3-1.69c1.33-7.55,2.72-15.1,4.39-22.58.06-.31.13-.62.2-.93s.38-.15.36.05c-.05.5-.1,1-.16,1.51q-.44,4.31-1,8.58c-.48,3.35-.81,6.72-1.28,10.07-.16,1.14-.32,2.28-.49,3.42-.77,5.51-1.57,11-2.51,16.51-.44,2.55-2,7.12,1.64,7.91a3.74,3.74,0,0,0,2.49-.31,7.82,7.82,0,0,0,3.41-4.31,57.21,57.21,0,0,0,1.95-9.18q.9-5,1.6-10.09h0q.9-6.31,1.88-12.61.49-3.21,1-6.42l.48-3C231.3,348.55,231.63,348.61,231.63,348.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.89,375.18a50,50,0,0,0,12.23-1.65c1.84-.47,3.66-1.06,5.47-1.65a14.19,14.19,0,0,0,4.94-2.48c2.78-2.4,4.07-6.17,5.28-9.53A92.18,92.18,0,0,0,175,348.3c0-.19.32-.12.33.06a44.83,44.83,0,0,1-1.67,13.13c-1,3.63-2.34,7.67-5.27,10.21s-7.26,3.62-11.21,4.1a51.64,51.64,0,0,1-13.32-.18A.22.22,0,0,1,143.89,375.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,348.42q-.33,8.32-.7,16.66-.85,19.41-1.87,38.82h-1.86q1.28-19.45,2.69-38.88.61-8.31,1.26-16.61A.24.24,0,0,1,137,348.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.91,380.78,114.4,370.58s27.06-107.25,80.49-146.68c13.66-10.07,28.61-3.61,35.34,3.92C247.33,247,249.31,380.35,248.91,380.78Z",
    style: {
      fill: "#66CC8A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.11,228.78a16.63,16.63,0,0,0-1.08,4.46,16,16,0,0,0,2.2-4,16.63,16.63,0,0,0,1.08-4.46A16.33,16.33,0,0,0,201.11,228.78Zm-14.6,57.86a15.63,15.63,0,0,0-1.07,4.47,17.89,17.89,0,0,0,3.26-8.5A16.14,16.14,0,0,0,186.51,286.64Zm-48.06,24.81a16.33,16.33,0,0,0-1.08,4.47,17.77,17.77,0,0,0,3.27-8.5A16.84,16.84,0,0,0,138.45,311.45ZM177.24,348a15.41,15.41,0,0,0-1.08,4.46,17.89,17.89,0,0,0,3.26-8.5A16,16,0,0,0,177.24,348Zm58.7-79.08a16.24,16.24,0,0,0-1.08,4.47,17.77,17.77,0,0,0,3.27-8.5A15.52,15.52,0,0,0,235.94,268.94ZM212,341.67a15.58,15.58,0,0,0-1.09,4.46,15.82,15.82,0,0,0,2.19-4,16.26,16.26,0,0,0,1.08-4.46A15.79,15.79,0,0,0,212,341.67ZM163.53,266.2a16.17,16.17,0,0,0-1.08,4.46,17.62,17.62,0,0,0,3.26-8.5A15.68,15.68,0,0,0,163.53,266.2ZM217.27,247a15.74,15.74,0,0,0-4.46-1.08,16,16,0,0,0,4,2.18,15.64,15.64,0,0,0,4.47,1.08A15.85,15.85,0,0,0,217.27,247Zm15.24,48.21a15.91,15.91,0,0,0-4.46-1.08,15.65,15.65,0,0,0,4,2.18,15.92,15.92,0,0,0,4.46,1.09A15.66,15.66,0,0,0,232.51,295.25Zm4.09,57.62a16.17,16.17,0,0,0-4.46-1.08,15.68,15.68,0,0,0,4,2.19,16.35,16.35,0,0,0,4.46,1.08A16.29,16.29,0,0,0,236.6,352.87Zm-95.75-4.74a16.09,16.09,0,0,0-4.46-1.08,17.68,17.68,0,0,0,8.49,3.27A16,16,0,0,0,140.85,348.13Zm34.61-37A16.19,16.19,0,0,0,171,310a16.06,16.06,0,0,0,4,2.2,16.63,16.63,0,0,0,4.46,1.08A16,16,0,0,0,175.46,311.12Zm51.45-85.83c-.14-.3-.28-.59-.43-.88h0c-.49-.37-1-.73-1.55-1.08a20.61,20.61,0,0,0,.9,2.46,15.73,15.73,0,0,0,2.39,3.92A16.31,16.31,0,0,0,226.91,225.29ZM187.6,256.36a15.91,15.91,0,0,0-2.39-3.92,17.57,17.57,0,0,0,3.7,8.32A15.79,15.79,0,0,0,187.6,256.36Zm34.71,118.33a16.18,16.18,0,0,0-2.38-3.92,16.12,16.12,0,0,0,1.3,4.4,16.8,16.8,0,0,0,2.19,3.68h.16A15.89,15.89,0,0,0,222.31,374.69ZM209.54,305a16.35,16.35,0,0,0-2.39-3.92,18,18,0,0,0,3.69,8.32A16.12,16.12,0,0,0,209.54,305Zm-91.62,53.14c-.06.21-.12.42-.19.62.13.14.25.29.37.43A8.85,8.85,0,0,0,117.92,358.17Zm40-26.68a16.17,16.17,0,0,0-2.39-3.91,17.59,17.59,0,0,0,3.7,8.31A16.24,16.24,0,0,0,157.89,331.49Zm8.58,38.5a16.22,16.22,0,0,0-2.39-3.92,17.93,17.93,0,0,0,3.7,8.33A16,16,0,0,0,166.47,370Zm67.27-46.32a16.42,16.42,0,0,0-3.92,2.39,16.13,16.13,0,0,0,4.4-1.31,16,16,0,0,0,3.93-2.39A16,16,0,0,0,233.74,323.67Zm-106.1,5.84-.51,1.38a14.15,14.15,0,0,0,3-1.95A12.51,12.51,0,0,0,127.64,329.51Zm68.58,33.32a16.06,16.06,0,0,0-3.92,2.38,16.29,16.29,0,0,0,4.41-1.3,16.46,16.46,0,0,0,3.92-2.4A15.64,15.64,0,0,0,196.22,362.83Zm-61.33,8.92-.69.33,2.35.18a13.88,13.88,0,0,0,2.74-1.82A16.35,16.35,0,0,0,134.89,371.75Zm23.56-82.23a17,17,0,0,0-3.92,2.39,17.93,17.93,0,0,0,8.33-3.69A16,16,0,0,0,158.45,289.52Zm34.48,38.3a16.26,16.26,0,0,0-3.92,2.4,17.81,17.81,0,0,0,8.33-3.7A16.29,16.29,0,0,0,192.93,327.82Zm18-52.65a16.75,16.75,0,0,0-3.92,2.39,17.69,17.69,0,0,0,8.32-3.69A16.22,16.22,0,0,0,210.9,275.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.61,250.23c-7.76-1.15-15.64-16.81-17-27.49-.09-.74,12-23.81,13.89-28.62.39-1,27.35,19.36,27.35,19.36s-7,8.92-10.27,17.35C236.35,231.53,230.11,251.33,222.61,250.23Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.89,213.48s-7,8.92-10.28,17.34c-.06.17-.46,1.41-1.12,3.18-13.86-7-19.51-19.5-21.79-27.75,2.62-5.25,5.06-10.18,5.84-12.13C219.93,193.13,246.89,213.48,246.89,213.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.73,156.65c-7.89,9.13-15.78,42.06-11.27,52.18,6.55,14.66,24,23.47,38.12,14.1,13.73-9.09,23.25-52.19,17.58-62.07C261.82,146.3,237.37,143.17,225.73,156.65Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.81,183.4c-1,.08-2,0-3,0a4.85,4.85,0,0,1-3.07-.6,1.56,1.56,0,0,1-.38-1.86,3.85,3.85,0,0,1,3.54-1.64,5.66,5.66,0,0,1,3.88,1.24A1.66,1.66,0,0,1,246.81,183.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.93,188.23c0-.09-.2.07-.22.17-.37,2.25-1.18,4.77-3.35,5.11-.07,0-.09.12,0,.13C244.89,193.78,245.93,190.43,245.93,188.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.39,185.49c-3.55-1-5.27,6.19-2,7.1S247.36,186.32,244.39,185.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.83,191c0-.08.15.15.13.24-.6,2.2-.92,4.83.91,6,.06,0,0,.15-.05.12C257.45,196.48,257.91,193,258.83,191Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.37,189.16c3.64.58,2.21,7.81-1.16,7.27S258.32,188.67,261.37,189.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.06,185.6a27.54,27.54,0,0,1-2.68-1.43,4.87,4.87,0,0,1-2.45-2,1.56,1.56,0,0,1,.54-1.83c1.23-.8,2.65-.43,3.91.19a5.71,5.71,0,0,1,2.87,2.92A1.67,1.67,0,0,1,265.06,185.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.49,207.48c.4.65.76,1.49,1.55,1.75a6,6,0,0,0,2.53,0,.08.08,0,0,1,.06.14,3.07,3.07,0,0,1-3.1.53,2.42,2.42,0,0,1-1.28-2.38C238.25,207.39,238.43,207.38,238.49,207.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.41,201.39a7.82,7.82,0,0,0,4.25,4.57,9.91,9.91,0,0,0,2.69.78,2.46,2.46,0,0,0,.53.06,4.06,4.06,0,0,0,.51,0,.55.55,0,0,0,.56-.39h0a2,2,0,0,0,0-.24h0l0-.2c.45-1.7.91-4.34.91-4.34.55.46,3.39,2.66,3.56,1.75,1.33-7.5,2.8-15.84,2.54-23.59a.21.21,0,0,0-.42,0c-1.56,7.16-1.85,14.55-3.31,21.77A13.32,13.32,0,0,0,251,199.6c-.26,0-.79,5.12-1.06,5.86a.44.44,0,0,1,0,.08c-3-.32-4.92-1.71-7.25-4.3C242.54,201.07,242.32,201.18,242.41,201.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.55,205.63a9.25,9.25,0,0,1-4.26,1.92,4.15,4.15,0,0,1-2.49-.43c-1.66-.89-1.32-2.53-.66-3.85a10,10,0,0,1,1.31-1.94A11.94,11.94,0,0,0,248.55,205.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.29,207.55a4.15,4.15,0,0,1-2.49-.43c-1.66-.89-1.32-2.53-.66-3.85C243,203.92,244.57,205.67,244.29,207.55Z",
    style: {
      fill: "#ff97b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.18,173.68c-14,5.86-28.16-10.35-28.16-10.35a13.63,13.63,0,0,1-15.3,5.62S223,189.22,217.52,188c-8.33-1.78-5-30.64-1.23-35.66s11.17-5,11.17-5,1.41-4.21,7.39-7.08c6.6-3.18,25,6.79,25,6.79a18.65,18.65,0,0,1,6.45-5.75,5.26,5.26,0,0,1,7.28,2.23,12.52,12.52,0,0,0-3.07,4.7c-2.25,5.88,2.72,6.91,3.83,1.38a8.81,8.81,0,0,0-.76-6.08c3.2-3.1,7.45-3.44,9.48-1C286.79,147,284.83,168.82,273.18,173.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.84,199.36a9.66,9.66,0,1,1,12.59-8.59h0a9.67,9.67,0,0,1-12.59,8.59Zm5.52-17.15a8.47,8.47,0,0,0-2-.39,8.39,8.39,0,1,0,2,.39Z",
    style: {
      fill: "#66CC8A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.15,203.4c-3.46-1.3-5.26-6-4-10.91a11.47,11.47,0,0,1,3.61-6.06,6,6,0,0,1,10,2.48,11.58,11.58,0,0,1,.35,7.05c-1.28,5.16-5.45,8.59-9.3,7.63A3.82,3.82,0,0,1,260.15,203.4Zm5.41-17.15-.47-.14a5.13,5.13,0,0,0-4.55,1.31,10.26,10.26,0,0,0-3.19,5.38c-1.11,4.48.54,8.76,3.71,9.54s6.63-2.22,7.74-6.69a10.21,10.21,0,0,0-.3-6.25A5.29,5.29,0,0,0,265.56,186.25Z",
    style: {
      fill: "#66CC8A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.9,191.81l-.62-1.13c1.67-.93,5.31-1.89,7.14,1l-1.1.68C254.69,189.77,251.05,191.72,250.9,191.81Z",
    style: {
      fill: "#66CC8A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.22,185.91l-1-.8c.38-.47,3.75-4.6,6.66-4.5,2.73.1,19.39,5,20.1,5.25l-.37,1.24c-4.78-1.42-17.66-5.13-19.77-5.2C211.9,181.83,209.13,184.77,208.22,185.91Z",
    style: {
      fill: "#66CC8A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.09,186.12s-2.69-12.88-8.25-12.33-6.5,17.12-2.05,21.35a5.84,5.84,0,0,0,8.43.2Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.69,178.55c-.08-.05-.15.06-.09.13,3.07,3.08,3.54,7.35,3.39,11.49-.52-1.84-1.7-3.24-4.1-2.71-.12,0-.09.21,0,.24a3.57,3.57,0,0,1,3.14,2.71,17.52,17.52,0,0,1,.49,3.68c0,.41.7.49.74,0a.34.34,0,0,1,0-.1C218.4,189.37,217.56,181.19,212.69,178.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.65,276.52c2.53-6.66,61.19,5.4,58.85,15.61-8.59,37.4-32.53,70.82-38.58,78.46-7.94,10-23.74,7.78-29.5,1.72C272.07,363.52,287.15,283.12,289.65,276.52Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.52,294.88a76.21,76.21,0,0,0-3.09,11c-.85,3.7-1.59,7.42-2.19,11.16a168.3,168.3,0,0,0-2,22.86c-.11,4.28,0,8.55,0,12.83,0,.1.16.09.16,0,0-3.79.23-7.61.54-11.39s.69-7.63,1.18-11.42c.95-7.45,2-14.89,3.35-22.28q.56-3.11,1.17-6.2c.43-2.14.92-4.27,1.2-6.44C285.84,294.84,285.59,294.7,285.52,294.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.5,171.11a103.6,103.6,0,0,1-2.28,15.13c-.19.85-.4,1.72-.61,2.58-.84,3.42-1.84,6.86-3,10.17q-.4,1.2-.84,2.37c-3.55,9.59-8.24,17.84-13.52,21.34A25.56,25.56,0,0,1,251,225a51.64,51.64,0,0,1-25.6-43.05l-1.6-.44c.25-.39.51-.79.76-1.21s.56-.95.83-1.45a51.61,51.61,0,0,1,14.58-34.37c12.57-3.38,27.62,1.45,33.95,12.48C275.46,159.69,275.93,164.83,275.5,171.11Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.15,180.83a30.84,30.84,0,0,1-3.19,0c-1.23,0-2.21.09-3.26-.64a1.64,1.64,0,0,1-.4-2c.77-1.36,2.27-1.71,3.75-1.74a6,6,0,0,1,4.11,1.31A1.76,1.76,0,0,1,249.15,180.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.22,186c0-.09-.21.08-.23.17-.39,2.39-1.25,5.06-3.55,5.42-.07,0-.09.13,0,.14C247.12,191.83,248.22,188.28,248.22,186Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.59,183.05c-3.76-1.05-5.58,6.55-2.1,7.52S249.74,183.93,246.59,183.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.89,188.88c0-.08.16.16.13.26-.64,2.33-1,5.11,1,6.4.06,0,0,.16-.05.13C260.43,194.68,260.91,191,261.89,188.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.58,186.93c3.85.62,2.33,8.28-1.24,7.71S261.35,186.41,264.58,186.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.48,183.16c-1-.43-1.87-1-2.83-1.51a5.22,5.22,0,0,1-2.6-2.09,1.65,1.65,0,0,1,.57-1.93c1.31-.85,2.81-.46,4.14.2a6,6,0,0,1,3,3.09A1.76,1.76,0,0,1,268.48,183.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.34,206.34c.43.68.81,1.57,1.65,1.85a6.17,6.17,0,0,0,2.67,0,.09.09,0,0,1,.07.15,3.25,3.25,0,0,1-3.29.56,2.57,2.57,0,0,1-1.35-2.52C240.08,206.24,240.27,206.24,240.34,206.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.5,199.88a8.24,8.24,0,0,0,4.49,4.85,10.36,10.36,0,0,0,2.85.82,2.86,2.86,0,0,0,.57.07,4.24,4.24,0,0,0,.53,0,.59.59,0,0,0,.6-.41v0a.93.93,0,0,0,0-.24v0l0-.21c.48-1.8,1-4.6,1-4.6.58.49,3.59,2.82,3.76,1.86,1.41-8,3-16.79,2.7-25a.22.22,0,0,0-.44,0c-1.66,7.58-2,15.41-3.51,23a14.45,14.45,0,0,0-3.51-2c-.27,0-.84,5.42-1.12,6.21a.25.25,0,0,1,0,.08c-3.13-.34-5.21-1.8-7.67-4.56C244.63,199.55,244.4,199.66,244.5,199.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,204.38a9.71,9.71,0,0,1-4.51,2,4.3,4.3,0,0,1-2.63-.46c-1.77-.94-1.4-2.68-.7-4.07a10.53,10.53,0,0,1,1.38-2.06A12.68,12.68,0,0,0,251,204.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.48,206.41a4.3,4.3,0,0,1-2.63-.46c-1.77-.94-1.4-2.68-.7-4.07C245.11,202.57,246.78,204.41,246.48,206.41Z",
    style: {
      fill: "#ff97b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.08,170.54c-.53.22-1.06.41-1.58.57-14.32,4.44-28.25-11.54-28.25-11.54a14.43,14.43,0,0,1-16.2,6,94.31,94.31,0,0,1-5.69,13.31,51.68,51.68,0,0,1,24.36-42.25A99.23,99.23,0,0,1,263,142.41a19.8,19.8,0,0,1,6.84-6.09,5.57,5.57,0,0,1,7.71,2.35,13.47,13.47,0,0,0-3.25,5c-2.38,6.22,2.88,7.31,4.05,1.46a9.31,9.31,0,0,0-.8-6.45c3.39-3.27,7.89-3.63,10-1C291.49,142.3,289.43,165.39,277.08,170.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.37,180.14a10.18,10.18,0,0,0-5.89-2.34,9.71,9.71,0,0,0-1.95.07,10.22,10.22,0,0,0-7.72,5.35,8.34,8.34,0,0,0-.56,1.26,9.79,9.79,0,0,0-.61,2.88,10.25,10.25,0,0,0,7.07,10.38,10.74,10.74,0,0,0,2.5.47l.64,0A10.25,10.25,0,0,0,254,189.52c0-.29.07-.58.09-.88s0-.44,0-.65A10.19,10.19,0,0,0,250.37,180.14Zm-7.08,16.7a8.86,8.86,0,0,1-1.12-17.54,8.7,8.7,0,0,1,2.23-.14,9,9,0,0,1,2.16.41,8.74,8.74,0,0,1,2.49,1.27,8.85,8.85,0,0,1-5.76,16Z",
    style: {
      fill: "#66CC8A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.4,186.67l-.18-.43a7.07,7.07,0,0,0-3-3.33,5.59,5.59,0,0,0-1.37-.54,5.88,5.88,0,0,0-2.13-.12,7.51,7.51,0,0,0-3.91,1.79,10.7,10.7,0,0,0-2.12,2.45,12.21,12.21,0,0,0-1.11,2.16,10.56,10.56,0,0,0-.5,1.5,2.8,2.8,0,0,0-.09.31,12.39,12.39,0,0,0,.18,6.89,7.26,7.26,0,0,0,4.11,4.67c.21.08.42.14.64.2a6.38,6.38,0,0,0,4.87-.86,11.65,11.65,0,0,0,5-7.23A12.21,12.21,0,0,0,273.4,186.67Zm-1,7.13a11.18,11.18,0,0,1-2.81,5.19,5.72,5.72,0,0,1-5.38,1.9c-3.36-.83-5.11-5.36-3.93-10.1a10.89,10.89,0,0,1,3.37-5.7,5.47,5.47,0,0,1,4.83-1.39,4,4,0,0,1,.49.15,5.65,5.65,0,0,1,3.12,3.34,8.55,8.55,0,0,1,.48,1.63A11.55,11.55,0,0,1,272.44,193.8Z",
    style: {
      fill: "#66CC8A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.48,189.74l-.65-1.2c1.77-1,5.63-2,7.56,1.1l-1.16.72C257.5,187.58,253.65,189.65,253.48,189.74Z",
    style: {
      fill: "#66CC8A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.55,183.44l-.39,1.31-.91-.27c-2.25-.66-5.57-1.62-8.88-2.54l-1.6-.44c.25-.39.51-.79.76-1.21l.81.23c4,1.1,7.87,2.23,9.47,2.7Z",
    style: {
      fill: "#66CC8A"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288,230.79a51.58,51.58,0,1,1,39.28-61.46A51.57,51.57,0,0,1,288,230.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.67,205.18a51.61,51.61,0,0,0,69.61,20.71Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.15,153.15l95.34,28.37a51.87,51.87,0,0,0-1.2-12.19,50.53,50.53,0,0,0-4.85-13.16l-70.38-20.95A51.62,51.62,0,0,0,233.15,153.15Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.71,186.44l90.81,27a52.07,52.07,0,0,0,5.69-8.37l-96.7-28.78A49.87,49.87,0,0,0,225.71,186.44Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.85,159.39l98,29.17c.1-.62.19-1.24.26-1.86l-97.48-29C230.36,158.25,230.09,158.81,229.85,159.39Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.38,129.56l43.5,12.94c-1.13-1.05-2.32-2-3.55-3L273,129A45.26,45.26,0,0,0,268.38,129.56Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 288.53,
    y: 234.15,
    width: 13.56,
    height: 59.63,
    transform: "translate(640.48 458.25) rotate(167.58)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.92,168.09a57.34,57.34,0,1,0-43.67,68.33A57.36,57.36,0,0,0,332.92,168.09ZM288,230.79a51.58,51.58,0,1,1,39.27-61.46A51.57,51.57,0,0,1,288,230.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "300.57 335.53 320.6 331.12 320.6 331.12 309.24 279.49 289.2 283.9 289.2 283.9 300.57 335.53",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.31,173.66a1.21,1.21,0,0,1-.05-.18c-.24-.86.26.83.08.27s-.44-1.35-.69-2a43.78,43.78,0,0,0-3.2-6.7c-.17-.3-.36-.6-.53-.9-.06-.1.44.7,0,.07l-.35-.54c-.46-.69-.93-1.37-1.42-2a41.06,41.06,0,0,0-3.53-4.16l-.92-.92c-.42-.41.49.45-.09-.08l-.58-.53c-.75-.65-1.52-1.28-2.32-1.88s-1.75-1.26-2.66-1.83c-.42-.26-.84-.51-1.27-.75-.74-.43.32.15-.23-.13l-.79-.4a40.64,40.64,0,0,0-7.46-2.8l-.13,0-.28-.06-1.15-.25c-.75-.15-1.49-.28-2.25-.39a47.62,47.62,0,0,0-4.79-.44,3.41,3.41,0,0,1,.77-6.78,43,43,0,0,1,27.56,11.13,47,47,0,0,1,11.52,16.87,34.22,34.22,0,0,1,1.46,4.39,3.42,3.42,0,0,1-2.84,3.9,3.49,3.49,0,0,1-3.9-2.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.71,183.71a3.36,3.36,0,1,0,2.79-3.83A3.36,3.36,0,0,0,310.71,183.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.56,303.82s14.32-23.54-3.51-46c-7.34-9.24-24.66-25.81-59.8-23.5-8.34.55-19.83,7.24-5.89,11.29,9.9,2.88,17.05,1.71,22.51,4.43,0,0-13.61,10.25-12.73,18.58.39,3.72.68,11.85,2.83,19.59,0,0,2.82,2,5.11,1.66,0,0,6.17,17.8,28.36,23.27Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.52,254.8c-5.74-2.29-18-6.93-29.35-7.25-12.61-.35-37,2.38-37.15,11.69-.12,6.83,9.28,6.6,9.28,6.6s-9.84,3.25-8.59,9.44c1.13,5.64,8.39,5,8.39,5s-5.63,3-3.49,8.22c2.57,6.28,13.94-1,22,3.08C296.47,292.54,333.52,254.8,333.52,254.8Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306,260.93c-5.75-1.26-19.56-.78-29.58,4.69-.23.12-.26.36,0,.29A124.25,124.25,0,0,1,306,261.05C306.09,261.05,306.09,261,306,260.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.3,273.65c-5.08-.58-19.29.55-29.25,6.44-.23.13-.24.37,0,.29a132.76,132.76,0,0,1,29.27-6.61A.06.06,0,0,0,305.3,273.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.77,314.67a60.95,60.95,0,0,1-14.62-5.53,40.68,40.68,0,0,1-12.11-10c-1-1.25-2-2.55-2.87-3.88s-1.83-2.84-2.86-4.16c-.08-.1-.27,0-.21.09a46.21,46.21,0,0,0,4.26,7.93,32.48,32.48,0,0,0,5.34,6.35,36.51,36.51,0,0,0,14,7.76,49.55,49.55,0,0,0,9,1.63C325.85,314.9,325.91,314.7,325.77,314.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.8,239.34c-25.76,34.59-68.75,124.74-75.07,138-4.29,9,42.74,32.7,44.73,26.16,2.56-8.38,44.61-119,50.5-159.33C203.18,222.06,188.71,227.37,179.8,239.34Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.73,399c-1.09,8.15-6.63,24.57-10.75,27.08s-25.77,2-36.68,2-13-3.05-12.87-6.8,23.07-4.47,23.07-4.47S82.92,425.53,75.23,427s-25.4,5.9-28-.47c-1.15-2.88,3.7-5.79,3.7-5.79s-7.43,2.17-8.62-1.52c-1.34-4.21,4.57-6.52,4.57-6.52s-4.65.93-4.76-2.5C41.92,402.5,71,398.74,71,398.74s-22.26,10.84-23,4.58c-1-8.65,44.64-18.14,49.39-21.91a89,89,0,0,0,9.67-9.39Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.59,423.14a3.38,3.38,0,0,1,1-2.92,9.5,9.5,0,0,1,2.66-1.72,35.67,35.67,0,0,1,6.25-2c4.3-1.09,8.71-1.86,13.1-3A53.75,53.75,0,0,0,100.16,415a24.68,24.68,0,0,0-6.43,2.46,8.7,8.7,0,0,0-2.69,2.3A3.48,3.48,0,0,0,90.59,423.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,420.7c3.15-.77,6.25-1.65,9.34-2.55s6.17-1.84,9.25-2.77l9.21-2.88c3.07-1,6.14-1.92,9.24-2.85a71.82,71.82,0,0,0-9.55,1.71c-3.16.72-6.26,1.62-9.35,2.56s-6.15,2-9.17,3.12S53.9,419.34,51,420.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.62,402a59.59,59.59,0,0,0-8.82,1.22,80.31,80.31,0,0,0-8.63,2.22,78.36,78.36,0,0,0-8.35,3.12,61.57,61.57,0,0,0-7.91,4.08c2.81-1,5.55-2.05,8.34-3s5.57-1.89,8.38-2.75,5.62-1.71,8.45-2.54S77.75,402.8,80.62,402Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.12,394.72a54.91,54.91,0,0,0-14,3,54.65,54.65,0,0,0-12.91,6.26c4.52-1.61,8.92-3.31,13.41-4.81S71.56,396.19,76.12,394.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.75,298.63l-52.2-1.44S167,251.91,182.24,235.3c15.91-17.3,24.57-15.81,19.14,14.84C195.91,281,190.75,298.63,190.75,298.63Z",
    style: {
      fill: "#66CC8A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.45,289.52a17,17,0,0,0-3.92,2.39,17.93,17.93,0,0,0,8.33-3.69A16,16,0,0,0,158.45,289.52Zm29.15-33.16a15.91,15.91,0,0,0-2.39-3.92,17.57,17.57,0,0,0,3.7,8.32A15.79,15.79,0,0,0,187.6,256.36Zm-24.07,9.84a16.17,16.17,0,0,0-1.08,4.46,17.62,17.62,0,0,0,3.26-8.5A15.68,15.68,0,0,0,163.53,266.2Zm23,20.44a15.63,15.63,0,0,0-1.07,4.47,17.89,17.89,0,0,0,3.26-8.5A16.14,16.14,0,0,0,186.51,286.64Zm15.3-59.45c-.25.52-.48,1.05-.7,1.59a16.63,16.63,0,0,0-1.08,4.46,16,16,0,0,0,2.2-4c.05-.13.09-.25.13-.38A10.49,10.49,0,0,0,201.81,227.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.48,289.55c-1.24-.18-2.51-.18-3.75-.24l-3.85-.21q-3.88-.19-7.79-.31c-5.2-.16-10.39-.34-15.58-.41-1.43,0-2.86,0-4.29,0s-3,.15-4.5.16c-.09,0-.08.14,0,.14,1.28.08,2.56.27,3.85.35s2.63.16,3.95.21c2.6.1,5.2.19,7.8.25,5.11.12,10.23.26,15.34.27H183c1.49,0,3,.08,4.5-.05C187.54,289.68,187.56,289.56,187.48,289.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.87,264.68c0-.1-.12-.16-.17-.06a39.44,39.44,0,0,0-2.48,5.55c.18-.91.39-1.82.56-2.74.57-2.94,1.09-5.9,1.67-8.84a.09.09,0,0,0-.17,0c-1.35,5.06-2.92,10.07-4.12,15.17s-2.41,10.2-3.53,15.32c-.61,2.83-1.16,6.36-1.78,9.18-1.51.18-3.45,0-5.08.21-.14,0-.1.25,0,.25,1.72.05,3.77.44,5.58.33.23,0,4.61-18.19,6.43-26.9C198.9,269.67,199.94,267.19,200.87,264.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238,236.4c-.73,2.39-1.56,4.75-2.51,7.06a38.16,38.16,0,0,1-2.91,6c-2.16,3.41-5.48,6.23-9.69,6.22-4,0-7.66-2.32-10.22-5.28-2.8-3.23-4.66-7.28-6.33-11.18-1-2.41-2-4.87-2.8-7.36-.41-1.26-.84-2.52-1.2-3.8s-.67-2.57-1.11-3.82c0-.1-.22-.09-.19,0,.74,2.88,2.89,12,3.75,14.32,1.58,4.25,3.36,8.64,6.21,12.22,2.7,3.38,6.37,5.94,10.76,6.36s8.15-1.89,10.57-5.37a28.15,28.15,0,0,0,3.3-7.07c.93-2.74,1.71-5.55,2.42-8.36C238.09,236.38,238,236.37,238,236.4Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Houses--inject-89"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "401.86 430.5 330.15 430.5 326.95 367.46 401.86 367.46 401.86 430.5",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.86 367.46 427.62 335.21 448.12 367.46 444.92 430.5 401.86 430.5 401.86 367.46",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.98 324.97 428.53 324.97 456.14 370.01 447.25 370.01 428.53 338.83 406.94 373.73 320.63 373.73 351.98 324.97",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.85,339.22H344.39l-8.78,10.52h19Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.38 347.94 348.38 360.75 339.22 360.75 339.22 347.94 343.8 342.21 348.38 347.94",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.38 347.93 355.58 347.93 348.38 360.75 348.38 347.93",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.96,
    y: 348.14,
    width: 5.21,
    height: 8.79,
    style: {
      fill: "#fbfaff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.6,
    y: 348.75,
    width: 1.68,
    height: 2.83,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.84,
    y: 348.75,
    width: 1.68,
    height: 2.83,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.6,
    y: 352.09,
    width: 1.68,
    height: 4.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.84,
    y: 352.09,
    width: 1.68,
    height: 4.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.15,339.22H384.69l-8.24,10.52h18.42Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "388.68 347.94 388.68 360.75 379.52 360.75 379.52 347.94 384.1 342.21 388.68 347.94",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "388.68 347.93 395.89 347.93 388.68 360.75 388.68 347.93",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.26,
    y: 348.14,
    width: 5.21,
    height: 8.79,
    style: {
      fill: "#fbfaff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.9,
    y: 348.75,
    width: 1.68,
    height: 2.83,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.15,
    y: 348.75,
    width: 1.68,
    height: 2.83,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.9,
    y: 352.09,
    width: 1.68,
    height: 4.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.15,
    y: 352.09,
    width: 1.68,
    height: 4.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.64,
    y: 323.15,
    width: 9.16,
    height: 12.06,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "414.8 323.15 422 323.15 422 325.09 414.8 335.21 414.8 323.15",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.61,
    y: 319.05,
    width: 10.19,
    height: 4.1,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.8,
    y: 319.05,
    width: 7.99,
    height: 4.1,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.73,
    y: 378.89,
    width: 11.34,
    height: 19.15,
    style: {
      fill: "#fbfaff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.13,
    y: 380.22,
    width: 3.65,
    height: 6.17,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.02,
    y: 380.22,
    width: 3.65,
    height: 6.17,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.13,
    y: 387.5,
    width: 3.65,
    height: 9.14,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.02,
    y: 387.5,
    width: 3.65,
    height: 9.14,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.85,
    y: 378.89,
    width: 11.34,
    height: 19.15,
    style: {
      fill: "#fbfaff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.25,
    y: 380.22,
    width: 3.65,
    height: 6.17,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.14,
    y: 380.22,
    width: 3.65,
    height: 6.17,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.25,
    y: 387.5,
    width: 3.65,
    height: 9.14,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.14,
    y: 387.5,
    width: 3.65,
    height: 9.14,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.73,
    y: 405.5,
    width: 11.34,
    height: 19.15,
    style: {
      fill: "#fbfaff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.13,
    y: 406.83,
    width: 3.65,
    height: 6.17,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.02,
    y: 406.83,
    width: 3.65,
    height: 6.17,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.13,
    y: 414.11,
    width: 3.65,
    height: 9.14,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.02,
    y: 414.11,
    width: 3.65,
    height: 9.14,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.85,
    y: 405.5,
    width: 11.34,
    height: 19.15,
    style: {
      fill: "#fbfaff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.25,
    y: 406.83,
    width: 3.65,
    height: 6.17,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.14,
    y: 406.83,
    width: 3.65,
    height: 6.17,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.25,
    y: 414.11,
    width: 3.65,
    height: 9.14,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.14,
    y: 414.11,
    width: 3.65,
    height: 9.14,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.73,
    y: 378.89,
    width: 11.34,
    height: 19.15,
    style: {
      fill: "#fbfaff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.13,
    y: 380.22,
    width: 3.65,
    height: 6.17,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.03,
    y: 380.22,
    width: 3.65,
    height: 6.17,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.13,
    y: 387.5,
    width: 3.65,
    height: 9.14,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.03,
    y: 387.5,
    width: 3.65,
    height: 9.14,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.73,
    y: 405.63,
    width: 11.34,
    height: 19.15,
    style: {
      fill: "#fbfaff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.13,
    y: 406.95,
    width: 3.65,
    height: 6.17,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.03,
    y: 406.95,
    width: 3.65,
    height: 6.17,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.13,
    y: 414.24,
    width: 3.65,
    height: 9.14,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.03,
    y: 414.24,
    width: 3.65,
    height: 9.14,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.24,
    y: 378.89,
    width: 11.34,
    height: 19.15,
    transform: "translate(855.82 776.93) rotate(180)",
    style: {
      fill: "#fbfaff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.53,
    y: 380.22,
    width: 3.65,
    height: 6.17,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.63,
    y: 380.22,
    width: 3.65,
    height: 6.17,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.53,
    y: 387.5,
    width: 3.65,
    height: 9.14,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.63,
    y: 387.5,
    width: 3.65,
    height: 9.14,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.24,
    y: 352.23,
    width: 11.34,
    height: 16.21,
    transform: "translate(855.82 720.67) rotate(180)",
    style: {
      fill: "#fbfaff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.53,
    y: 353.55,
    width: 3.65,
    height: 6.17,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.63,
    y: 353.55,
    width: 3.65,
    height: 6.17,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.53,
    y: 360.9,
    width: 3.65,
    height: 6.17,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.63,
    y: 360.9,
    width: 3.65,
    height: 6.17,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.69,
    y: 405.68,
    width: 13.75,
    height: 24.97,
    transform: "translate(853.15 838.34) rotate(-179.73)",
    style: {
      fill: "#fbfaff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.74,
    y: 407.78,
    width: 3.74,
    height: 2.96,
    transform: "translate(16.32 834.93) rotate(-89.73)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.86,
    y: 407.77,
    width: 3.74,
    height: 2.96,
    transform: "translate(12.48 831.03) rotate(-89.73)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.41,
    y: 423.79,
    width: 6.25,
    height: 0.9,
    transform: "translate(853.06 850.51) rotate(-179.73)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.62,
    y: 407.8,
    width: 3.74,
    height: 2.96,
    transform: "matrix(0, -1, 1, 0, 20.17, 838.83)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.72,
    y: 412.51,
    width: 3.74,
    height: 2.96,
    transform: "translate(11.58 839.61) rotate(-89.73)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.84,
    y: 412.49,
    width: 3.74,
    height: 2.96,
    transform: "translate(7.72 835.7) rotate(-89.73)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.6,
    y: 412.53,
    width: 3.74,
    height: 2.96,
    transform: "translate(15.42 843.51) rotate(-89.73)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.69,
    y: 417.24,
    width: 3.74,
    height: 2.96,
    transform: "translate(6.83 844.29) rotate(-89.73)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.81,
    y: 417.22,
    width: 3.74,
    height: 2.96,
    transform: "translate(2.98 840.39) rotate(-89.73)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.57,
    y: 417.26,
    width: 3.74,
    height: 2.96,
    transform: "translate(10.67 848.19) rotate(-89.73)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.5 430.67 140.8 430.67 137.95 399.8 204.5 399.8 204.5 430.67",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.48 399.76 227.36 371.12 245.58 399.76 242.73 430.63 204.48 430.63 204.48 399.76",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.81 362.06 229 362.06 254.63 405.37 247.64 405.37 228.06 372.77 209.25 405.37 132.59 405.37 159.81 362.06",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.68,
    y: 411.26,
    width: 10.08,
    height: 14.4,
    style: {
      fill: "#fbfaff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.92,
    y: 412.44,
    width: 3.24,
    height: 5.48,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.27,
    y: 412.44,
    width: 3.24,
    height: 5.48,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.92,
    y: 418.96,
    width: 3.24,
    height: 5.48,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.27,
    y: 418.96,
    width: 3.24,
    height: 5.48,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.7,
    y: 411.26,
    width: 10.08,
    height: 14.4,
    style: {
      fill: "#fbfaff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.94,
    y: 412.44,
    width: 3.24,
    height: 5.48,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.29,
    y: 412.44,
    width: 3.24,
    height: 5.48,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.94,
    y: 418.96,
    width: 3.24,
    height: 5.48,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.29,
    y: 418.96,
    width: 3.24,
    height: 5.48,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.22,
    y: 410.49,
    width: 11.11,
    height: 20.18,
    style: {
      fill: "#fbfaff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.58,
    y: 411.88,
    width: 2.39,
    height: 3.02,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.72,
    y: 411.88,
    width: 2.39,
    height: 3.02,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.25,
    y: 425.13,
    width: 5.05,
    height: 0.73,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.44,
    y: 411.88,
    width: 2.39,
    height: 3.02,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.58,
    y: 415.7,
    width: 2.39,
    height: 3.02,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.72,
    y: 415.7,
    width: 2.39,
    height: 3.02,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.44,
    y: 415.7,
    width: 2.39,
    height: 3.02,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.58,
    y: 419.52,
    width: 2.39,
    height: 3.02,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.72,
    y: 419.52,
    width: 2.39,
    height: 3.02,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.44,
    y: 419.52,
    width: 2.39,
    height: 3.02,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.31,
    y: 360.33,
    width: 8.14,
    height: 10.71,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.45 360.33 180.85 360.33 180.85 362.05 174.45 371.04 174.45 360.33",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.4,
    y: 356.68,
    width: 9.05,
    height: 3.64,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.45,
    y: 356.68,
    width: 7.1,
    height: 3.64,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "229.68 430.68 250.34 430.68 252.31 409.39 229.68 409.39 229.68 430.68",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "229.68 409.39 219.47 404.78 219.7 430.68 229.68 430.68 229.68 409.39",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.81,
    y: 414.9,
    width: 8.69,
    height: 15.77,
    style: {
      fill: "#fbfaff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.22,
    y: 415.98,
    width: 1.87,
    height: 2.36,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.67,
    y: 415.98,
    width: 1.87,
    height: 2.36,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.18,
    y: 425.28,
    width: 3.95,
    height: 0.57,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.77,
    y: 415.98,
    width: 1.87,
    height: 2.36,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "217.91 403.72 247.93 403.72 257.63 411.1 228.81 411.1 217.91 403.72",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.81 411.1 217.91 411.1 217.91 403.72 228.81 411.1",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.36,392.93a5.15,5.15,0,1,0,5.14-5.15A5.15,5.15,0,0,0,222.36,392.93Z",
    style: {
      fill: "#fbfaff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.51,392.93a4,4,0,0,0,4,4,3.71,3.71,0,0,0,1-.13,4,4,0,0,0-1-7.86,3.78,3.78,0,0,0-1,.13,3.63,3.63,0,0,0-1.29.6A4,4,0,0,0,223.51,392.93Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.95,
    y: 388.14,
    width: 1.11,
    height: 9.48,
    transform: "translate(455.01 785.77) rotate(180)",
    style: {
      fill: "#fbfaff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.95,
    y: 388.14,
    width: 1.11,
    height: 9.48,
    transform: "translate(620.39 165.38) rotate(90)",
    style: {
      fill: "#fbfaff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.12 430.68 226.93 430.68 224.73 406.87 259.12 406.87 259.12 430.68",
    style: {
      fill: "#66CC8A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.12 430.68 226.93 430.68 224.73 406.87 259.12 406.87 259.12 430.68",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.12 406.87 276.77 384.77 290.82 406.87 288.63 430.68 259.12 430.68 259.12 406.87",
    style: {
      fill: "#66CC8A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.25 409.78 217.57 409.78 244.14 376.37 276.95 376.37 296.67 409.78 291.66 409.78 276.95 386.89 261.25 409.78",
    style: {
      fill: "#66CC8A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.25 409.78 217.57 409.78 244.14 376.37 276.95 376.37 296.67 409.78 291.66 409.78 276.95 386.89 261.25 409.78",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.23,
    y: 346.82,
    width: 9.1,
    height: 11.98,
    style: {
      fill: "#66CC8A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.23,
    y: 346.82,
    width: 9.1,
    height: 11.98,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.33,
    y: 346.82,
    width: 7.16,
    height: 11.98,
    style: {
      fill: "#66CC8A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.21,
    y: 342.74,
    width: 10.12,
    height: 4.07,
    style: {
      fill: "#66CC8A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.21,
    y: 342.74,
    width: 10.12,
    height: 4.07,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.33,
    y: 342.74,
    width: 7.94,
    height: 4.07,
    style: {
      fill: "#66CC8A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.33,
    y: 342.74,
    width: 7.94,
    height: 4.07,
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.31 430.65 266.06 430.65 262.87 396.12 337.31 396.12 337.31 430.65",
    style: {
      fill: "#66CC8A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.31 430.65 266.06 430.65 262.87 396.12 337.31 396.12 337.31 430.65",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.31 396.12 362.9 364.07 383.28 396.12 380.09 430.65 337.31 430.65 337.31 396.12",
    style: {
      fill: "#66CC8A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.59 366.1 383.63 398.64 390.98 398.64 363.22 353.9 287.43 353.9 249.03 402.35 341.6 402.35 362.59 366.1",
    style: {
      fill: "#66CC8A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.59 366.1 383.63 398.64 390.98 398.64 363.22 353.9 287.43 353.9 249.03 402.35 341.6 402.35 362.59 366.1",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.25,
    y: 384.85,
    width: 11.27,
    height: 16.11,
    transform: "translate(723.77 785.82) rotate(180)",
    style: {
      fill: "#fbfaff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.5,
    y: 386.17,
    width: 3.63,
    height: 6.13,
    style: {
      fill: "#66CC8A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.64,
    y: 386.17,
    width: 3.63,
    height: 6.13,
    style: {
      fill: "#66CC8A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.5,
    y: 393.47,
    width: 3.63,
    height: 6.13,
    style: {
      fill: "#66CC8A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.64,
    y: 393.47,
    width: 3.63,
    height: 6.13,
    style: {
      fill: "#66CC8A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.75,
    y: 408.93,
    width: 11.27,
    height: 16.11,
    style: {
      fill: "#fbfaff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.14,
    y: 410.25,
    width: 3.63,
    height: 6.13,
    style: {
      fill: "#66CC8A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.01,
    y: 410.25,
    width: 3.63,
    height: 6.13,
    style: {
      fill: "#66CC8A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.14,
    y: 417.55,
    width: 3.63,
    height: 6.13,
    style: {
      fill: "#66CC8A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.01,
    y: 417.55,
    width: 3.63,
    height: 6.13,
    style: {
      fill: "#66CC8A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.46,
    y: 408.93,
    width: 11.27,
    height: 16.11,
    style: {
      fill: "#fbfaff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.84,
    y: 410.25,
    width: 3.63,
    height: 6.13,
    style: {
      fill: "#66CC8A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.71,
    y: 410.25,
    width: 3.63,
    height: 6.13,
    style: {
      fill: "#66CC8A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.84,
    y: 417.55,
    width: 3.63,
    height: 6.13,
    style: {
      fill: "#66CC8A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.71,
    y: 417.55,
    width: 3.63,
    height: 6.13,
    style: {
      fill: "#66CC8A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.16,
    y: 408.93,
    width: 11.27,
    height: 16.11,
    style: {
      fill: "#fbfaff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.55,
    y: 410.25,
    width: 3.63,
    height: 6.13,
    style: {
      fill: "#66CC8A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.41,
    y: 410.25,
    width: 3.63,
    height: 6.13,
    style: {
      fill: "#66CC8A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.55,
    y: 417.55,
    width: 3.63,
    height: 6.13,
    style: {
      fill: "#66CC8A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.41,
    y: 417.55,
    width: 3.63,
    height: 6.13,
    style: {
      fill: "#66CC8A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.67,
    y: 408.08,
    width: 12.43,
    height: 22.57,
    transform: "translate(723.77 838.72) rotate(180)",
    style: {
      fill: "#fbfaff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.55,
    y: 409.63,
    width: 2.68,
    height: 3.38,
    style: {
      fill: "#66CC8A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.04,
    y: 409.63,
    width: 2.68,
    height: 3.38,
    style: {
      fill: "#66CC8A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.06,
    y: 424.45,
    width: 5.65,
    height: 0.82,
    transform: "translate(723.77 849.72) rotate(180)",
    style: {
      fill: "#66CC8A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.05,
    y: 409.63,
    width: 2.68,
    height: 3.38,
    style: {
      fill: "#66CC8A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.55,
    y: 413.9,
    width: 2.68,
    height: 3.38,
    style: {
      fill: "#66CC8A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.04,
    y: 413.9,
    width: 2.68,
    height: 3.38,
    style: {
      fill: "#66CC8A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.05,
    y: 413.9,
    width: 2.68,
    height: 3.38,
    style: {
      fill: "#66CC8A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.55,
    y: 418.17,
    width: 2.68,
    height: 3.38,
    style: {
      fill: "#66CC8A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.04,
    y: 418.17,
    width: 2.68,
    height: 3.38,
    style: {
      fill: "#66CC8A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.05,
    y: 418.17,
    width: 2.68,
    height: 3.38,
    style: {
      fill: "#66CC8A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.77,365.5H300.41L292,376h18.52Z",
    style: {
      fill: "#66CC8A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.77,365.5H300.41L292,376h18.52Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304.38 374.16 304.38 386.89 295.27 386.89 295.27 374.16 299.83 368.47 304.38 374.16",
    style: {
      fill: "#66CC8A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304.38 374.16 304.38 386.89 295.27 386.89 295.27 374.16 299.83 368.47 304.38 374.16",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304.38 374.16 311.54 374.16 304.38 386.89 304.38 374.16",
    style: {
      fill: "#66CC8A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297,
    y: 374.36,
    width: 5.17,
    height: 8.73,
    style: {
      fill: "#fbfaff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.64,
    y: 374.96,
    width: 1.67,
    height: 2.81,
    style: {
      fill: "#66CC8A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.87,
    y: 374.96,
    width: 1.67,
    height: 2.81,
    style: {
      fill: "#66CC8A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.64,
    y: 378.29,
    width: 1.67,
    height: 4.17,
    style: {
      fill: "#66CC8A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.87,
    y: 378.29,
    width: 1.67,
    height: 4.17,
    style: {
      fill: "#66CC8A"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Cat);
export default __webpack_public_path__ + "static/media/404-cat.5cc2ed93d7ce06b5088d857170cd724b.svg";
export { ForwardRef as ReactComponent };